var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstalmentCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27156",
    "data-name": "Group 27156",
    transform: "translate(-89 -29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27153",
    "data-name": "Group 27153",
    transform: "translate(89 29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    d: "M14,2.1A11.9,11.9,0,0,0,5.585,22.415,11.9,11.9,0,0,0,22.415,5.585,11.822,11.822,0,0,0,14,2.1M14,0A14,14,0,1,1,0,14,14,14,0,0,1,14,0Z",
    transform: "translate(0)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27451",
    "data-name": "Group 27451",
    transform: "translate(454.432 -399.649) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_384",
    "data-name": "Line 384",
    x2: 12,
    transform: "translate(58.5 561.5)",
    fill: "none",
    stroke: "#dedede",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_385",
    "data-name": "Line 385",
    x2: 12,
    transform: "translate(64.5 555.5) rotate(90)",
    fill: "none",
    stroke: "#dedede",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstalmentCancelled);
export default __webpack_public_path__ + "static/media/instalment-cancelled.c4410bd9cc06da469917e62ad079a3dc.svg";
export { ForwardRef as ReactComponent };